import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_IMAGE_GALLERY_IMAGE](state, p) {
    const drp = p.drp;
    drp.images.push(p.newImage);
  },
  [types.REMOVE_IMAGE_GALLERY_IMAGE](state, p) {
    const drp = p.drp;
    drp.images.splice(p.imgIndex, 1);
  },
  [types.SET_IMAGE_GALLERY_FIRST](state, p) {
    const drp = p.drp;
    drp.firstUpload = p.value;
    // if changing to first upload, clear images
    if (p.value) {
      drp.images = [];
    }
  },
  [types.SET_IMAGE_GALLERY_LIMITS](state, p) {
    const drp = p.drp;
    drp.itemLimit = p.itemLimit;
    drp.showAll = p.showAll;
  },
};

const actions = {
  addImageGalleryImage: ({ commit }, payload) => {
    commit(types.ADD_IMAGE_GALLERY_IMAGE, payload);
  },
  setImageGalleryLimits: ({ commit }, payload) => {
    commit(types.SET_IMAGE_GALLERY_LIMITS, payload);
  },
  setImageGalleryFirst: ({ commit }, payload) => {
    commit(types.SET_IMAGE_GALLERY_FIRST, payload);
  },
  removeImageGalleryImg: ({ commit }, payload) => {
    commit(types.REMOVE_IMAGE_GALLERY_IMAGE, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/image-gallery/vuex.js